export const BTN_PLUS  = 1;
export const BTN_MINUS = -1;
export const BTN_NONE  = 0;